
;(function($, window, document, undefined) {
	"use strict";

	var defaults   = {
		resultsContainer: ".search-results",
        monitorSelector: "",
		searchUrl: "search.php",
		searchVar: null,
        searchField: null,
        searchData: [],
		onSearchStart: function() {},
		onSearchComplete: function() {},
		ignoreEmpty: true
	};

	function quickSearch(element, options) {
		this.timeout  = false;
		this.request  = false;
		this.element  = element;
		this.settings = $.extend({}, defaults, options);
		this.init();
	}

	$.extend(quickSearch.prototype, {
		init: function() {
		    this.$monitorElement = this.settings.monitorSelector == '' ? $(this.element) : $(this.element).find(this.settings.monitorSelector);

            if (this.$monitorElement.filter('select,input').length > 0) {
                this.$monitorElement = this.$monitorElement.filter('select,input');
            } else {
                this.$monitorElement = this.$monitorElement.find('select,input');
            }

            if (this.settings.searchVar === null) {
                this.settings.searchVar = $(this.element).attr('name');
            }

            if (this.settings.searchField === null) {
                this.settings.searchField = this.settings.monitorSelector == '' ? this.element : this.settings.monitorSelector;
            }

			this.loadResults();
			this.monitor();
		},

		monitor: function() {
			var self = this;

			if (self.timeout != false) {
				clearTimeout(self.timeout);
			}

			this.$monitorElement.filter('input[type=text]').on('input', function() {
			    self.timeout = setTimeout(self.loadResults(), 200);
            });

			this.$monitorElement.filter('input[type!=text]').on('change', function() {
				self.timeout = setTimeout(self.loadResults(), 200);
			});
		},

		loadResults: function() {
		    var self       = this;
			var searchVal  = $(this.settings.searchField).val();
			var searchData = this.settings.searchData.slice(0);

			if (this.settings.ignoreEmpty && searchVal == '') return;

			if (typeof searchData == 'string') {
			    searchData = $(searchData).serializeArray();
            }

            if (searchVal !== '') {
                searchData.push({
                    name: this.settings.searchVar,
                    value: searchVal
                });
            }

            if (typeof this.request.abort == 'function') {
			    this.request.abort();
            }

            this.settings.onSearchStart();
			this.request = $.ajax({
                url: this.settings.searchUrl,
                data: searchData
			}).always(function(data) {
                $(self.settings.resultsContainer).html(data);
                self.settings.onSearchComplete();
            });
		}
	});

	$.fn['quickSearch'] = function(options) {
		return this.each(function() {
			if (!$.data(this, "quickSearch")) {
				$.data(this, "quickSearch", new quickSearch(this, options));
			}
		});
	};

})(jQuery, window, document);